export default defineNuxtRouteMiddleware((to) => {
  const { availableLocale } = useLocale()
  const target = getSportRootRedirect(to.path, availableLocale)

  if (!target) {
    return
  }

  return navigateTo(
    {
      hash: to.hash,
      path: target,
      query: to.query,
    },
    { redirectCode: 301, replace: true },
  )
})
